import React from 'react';
import clsx from 'clsx';
import { createStyles, makeStyles } from '@material-ui/styles';
import { darken } from '@material-ui/core';
import { JupiterTheme, SummaryCard } from '@jupiterone/jupiter-web-toolkit';
import {
  InAppNotification,
  topicInformation,
} from '@jupiterone/notification-types';
import NotificationIcon from 'navbar/src/notifications/NotificationsDrawer/NotificationCard/NotificationIcon';
import { formatNotificationDateTime } from 'navbar/src/notifications/util/formatNotificationDateTime';

const useStyles = makeStyles((theme: JupiterTheme) =>
  createStyles({
    read: {
      color: theme.palette.grey[400],
      backgroundColor: theme.palette.background.main,
      '&:hover': {
        backgroundColor: darken(theme.palette.background.main, 0.15),
      },
    },
    unread: {
      color: 'white',
      backgroundColor: theme.palette.grey[800],
      '&:hover': {
        backgroundColor: theme.palette.background.main,
      },
    },
  })
);

interface NotificationCardProps extends InAppNotification {
  onClick: () => void;
  className?: string;
}
const NotificationCard = ({
  notificationId,
  topic,
  body,
  readDate,
  createdAt,
  className,
  onClick,
}: NotificationCardProps) => {
  const classes = useStyles();
  const { category, severity, displayName } = topicInformation[topic];

  return (
    <SummaryCard
      className={clsx(readDate ? classes.read : classes.unread, className)}
      id={notificationId}
      title={displayName}
      category={category}
      message={body?.message}
      icon={<NotificationIcon category={category} severity={severity} />}
      onClick={onClick}
      subtext={formatNotificationDateTime(createdAt)}
      isExpandable={true}
    />
  );
};

export default NotificationCard;
